export default __webpack_public_path__ + "static/media/box_pc@2x.c03570d9.png";